import { Component } from 'react';
import { connect } from 'react-redux';

import { Layout, Title, Pagination } from 'common/components/layout';
import { isPreSale } from 'common/helpers/featureFlags';
import { getClubList } from 'common/helpers/miscHelper';
import {
  concatUrlString,
  pageFromQuery,
  urlPushQuery,
  queryStringFromProps
} from 'common/helpers/searchHelper';
import SubMenu from 'profile/common/SubMenu';
import {
  listClubMemberships,
  resetClubMembershipQuery
} from 'redux/clubMemberships/actions';

import ClubMembershipDisplay from './list/ClubMembershipDisplay';

class ClubMembershipList extends Component {
  componentDidMount() {
    const { props } = this;
    props.resetClubMembershipQuery();
    const urlString = queryStringFromProps(props);
    props.listClubMemberships(urlString);
  }

  search = (page) => {
    const { props } = this;
    props.resetClubMembershipQuery();
    const urlString = concatUrlString(page);
    props.listClubMemberships(urlString);
    props.history.push(urlPushQuery('/profile/club-membership', urlString));
  };

  render() {
    const { location, settings, clubMemberships } = this.props;
    const page = pageFromQuery(location.search);
    if (
      !settings.data ||
      !clubMemberships.data ||
      clubMemberships.query === null
    ) {
      return (
        <Layout title="Club Memberships" loading>
          <Title>Your Account</Title>
          <SubMenu />
        </Layout>
      );
    }
    let title = 'Club Memberships';
    let link = 'club membership';
    if (isPreSale()) {
      title = 'Pre-Sale Selection';
      link = 'selection';
    }

    return (
      <Layout title="Club Memberships">
        <Title>Your Account</Title>
        <SubMenu />
        <div className="c7-account__clubs">
          <h2>{title}</h2>
          {clubMemberships.query.map((clubMembershipId) => {
            const clubMembership = clubMemberships.data[clubMembershipId];
            return (
              <ClubMembershipDisplay
                key={clubMembership.id}
                clubMembership={clubMembership}
              />
            );
          })}
          <Pagination
            totalRecords={clubMemberships.recordCount}
            page={page || 1}
            search={this.search}
          />
          <div className="c7-account-row c7-account-row--add c7-account-row--add-club">
            <a href={`${getClubList(settings)}`} className="c7-button-small">
              Add a new {link}
            </a>
          </div>
        </div>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => ({
  clubMemberships: state.clubMembership,
  settings: state.setting
});

export default connect(mapStateToProps, {
  listClubMemberships,
  resetClubMembershipQuery
})(ClubMembershipList);
